import PropTypes from 'prop-types';
import React, { useState } from 'react';

import {
    IconArrowRight,
    IconChevronSprite,
} from '$partials/icons/index.js';

import Image from '$partials/media/image.jsx';

import {
    CarouselProvider,
    CarouselContextConsumer
} from '$contexts/carousel.jsx';

import Carousel, { CarouselSlide } from '$partials/ui/carousel.jsx';

import Button from '$partials/ui/button.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const ModuleWalkthroughMobile = ({
    eyebrow,
    title,
    itemsCollection,
    itemsVariant,
    mainCtaLabel,
    mainCtaLink,
    standfirst,
    parent
}) => {

    // Todo: check spacing around text after DN figma updates

    return (
        <div className={`block md:hidden bg-white relative overflow-hidden ${parent === 'Home' ? 'py-40' : parent === 'Detail' ? 'py-20' : 'py-40'}`}>
            <div className='layout-container'>
                <div className='bg-white'>
                    <section className='module-walk-through'>
                        {eyebrow && (
                            <h1
                                className='type-style-5 text-core-brand px-10 sm:px-5'>
                                {eyebrow}
                            </h1>
                        )}

                        <h2 className='type-style-2 text-grey-black mt-12 px-10 sm:px-5'>
                            {title}
                        </h2>

                        {standfirst && (
                            <p className='type-style-8 text-grey-off-black mt-9 px-10 sm:px-5 sm:w-10/12'>
                                {standfirst}
                            </p>
                        )}

                        {/* Desktop */}
                        <div className='mt-64 w-screen max-w-screen left-1/2 relative -translate-x-1/2'>
                            <CarouselProvider>
                                <div className='layout-container overflow-visible mt-30'>

                                    <Carousel className='flex swiper-wrapper h-auto w-full relative'>

                                        {itemsCollection?.items?.length > 0 && (
                                            itemsCollection?.items?.map((itm, idx) => {

                                                return (
                                                    <CarouselSlide
                                                        className='flex flex-col w-full sm:w-11/12 relative pb-5'
                                                        index={idx}
                                                        key={`${idx}`}>
                                                        <div className='mx-10 sm:mx-5 h-full'>
                                                            <div className='px-15 py-25 sm:p-25 rounded-button flex flex-col sm:flex-row gap-25 bg-sand'>
                                                                <div className='sm:w-1/2 flex flex-col justify-between'>
                                                                    <div>
                                                                        {itemsVariant === 'Numbered' ?
                                                                            <span className='text-orange type-style-4'>
                                                                                {`0${idx + 1}`}
                                                                            </span> :
                                                                            null
                                                                        }
                                                                        <div>
                                                                            <h3 className='type-style-4 font-[500]'>
                                                                                {itm?.heading}
                                                                            </h3>
                                                                            <div>
                                                                                <p className='mt-5 type-style-8 text-grey-off-black'>
                                                                                    {itm?.copy}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {itm?.ctaLabel && itm?.ctaLink && !mainCtaLink && !mainCtaLabel && (
                                                                        <p className='mt-25 sm:mt-0'>
                                                                            {/* todo - check mobile margin top */}
                                                                            <a
                                                                                className='inline-flex items-center gap-5 type-style-5 text-core-brand'
                                                                                href={itm?.ctaLink}>
                                                                                <span>
                                                                                    {itm?.ctaLabel}
                                                                                </span>
                                                                                <span>
                                                                                    <IconArrowRight />
                                                                                </span>
                                                                            </a>
                                                                        </p>
                                                                    )}
                                                                </div>
                                                                <div className='sm:w-1/2'>
                                                                    <div className='aspect-square pointer-events-none select-none'>
                                                                        <figure className='h-full w-full rounded-button overflow-hidden'>
                                                                            {/* To do - check mobile media size - fixed? */}
                                                                            {itm?.media?.contentType?.includes('video/') ?
                                                                                (
                                                                                    <video
                                                                                        autoPlay
                                                                                        loop
                                                                                        muted
                                                                                        playsInline
                                                                                        className='w-full h-full object-cover'
                                                                                        src={itm?.media?.src}
                                                                                        width={'100%'}/>
                                                                                ) :  (
                                                                                    <Image
                                                                                        {...itm?.media}
                                                                                        className='h-full w-full object-center object-cover select-none pointer-events-none'
                                                                                        containerClassName='w-full h-full relative'
                                                                                        height='100%'
                                                                                        loadWidth={2560}
                                                                                        width='100%' />
                                                                                )
                                                                            }
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CarouselSlide>
                                                );
                                            })
                                        )}
                                    </Carousel>
                                </div>


                                {/* Button */}
                                <div className='mt-20 layout-container items-center flex justify-between'>
                                    <div className='flex gap-x-8 ml-10 sm:ml-5'>

                                        <CarouselContextConsumer>
                                            {({ currentIndex }) => (
                                                [...Array(itemsCollection?.items?.length).keys()].map((col, i) => {
                                                    return (
                                                        <svg
                                                            className='inline'
                                                            key={i}
                                                            style={{ width: '12px', height: '12px' }}
                                                            viewBox='0 0 12 12'
                                                            xmlns='http://www.w3.org/2000/svg'>
                                                            <circle
                                                                cx='6'
                                                                cy='6'
                                                                fill={  currentIndex === i ? '#FC5200' : '#D9D9D9'}
                                                                r='6' />
                                                        </svg>
                                                    );
                                                })
                                            )}
                                        </CarouselContextConsumer>
                                    </div>
                                    {mainCtaLabel && mainCtaLink && (
                                        <Button
                                            as='a'
                                            className='button button--secondary-alt mr-10 sm:mr-5'
                                            href={mainCtaLink}
                                            type='button'>
                                            <span>{mainCtaLabel}</span>
                                            <span className='button__icon button__icon--animate'>
                                                <IconChevronSprite />
                                            </span>
                                        </Button>
                                    )}
                                </div>
                            </CarouselProvider>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    itemsCollection: PropTypes.object,
    itemsVariant: PropTypes.string,
    mainCtaLabel: PropTypes.string,
    mainCtaLink: PropTypes.string,
    standfirst: PropTypes.string,
    parent: PropTypes.string,
};

ModuleWalkthroughMobile.propTypes = propTypes;

export default ModuleWalkthroughMobile;
